import React, { useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import { abouts } from "../../constants";
import "./ProjectDetails.scss";

function ProjectDetails() {
  const ref = useRef();
  const params = useParams();
  const projectId = parseInt(params.id);

  // Find the project details based on the ID
  const project = abouts.find((item) => item.id === projectId);

  useEffect(() => {
    if (!project) return;

    // Check if the ref is defined before attempting to scroll
    if (ref.current) {
      // You can adjust the behavior of the scroll (smooth or instant) based on your preference
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [projectId, project]);

  if (!project) {
    return <div>Project not found</div>;
  }

  // Function to filter projects by category except the current project
  const relatedProjects = abouts.filter(
    (item) => item.category === project.category && item.id !== projectId
  );

  return (
    <div className="project-details">
      <div className="button">
        <Link to="/">Home Page</Link>
      </div>

      <div ref={ref} className="project-details-alt">
        <div className="project-details-left">
          <h2>{project.title}</h2>
          <p>Category: {project.category}</p>
          <p>Technologies: {project.tec}</p>
          <p className="explanation">Explanation: {project.explanation}</p>
          <p>
            <a href={project.url} target="_blank" rel="noopener noreferrer">
              => Live Link
            </a>
          </p>
          <p>
            <a href={project.github} target="_blank" rel="noopener noreferrer">
              => GitHub Link
            </a>
          </p>
          {/* You can add more details or modify the structure as needed */}
        </div>

        <div className="project-details-right">
          <img src={project.imgUrl} alt={project.title} />
        </div>
      </div>

      <div className="related-projects">
        <h3>{project.category}-Related Projects</h3>

        <ul>
          {relatedProjects.map((relatedProject) => (
            <li key={relatedProject.id}>
              <Link className="specifik-link" to={`/${relatedProject.id}`}>
                <img src={relatedProject.imgUrl} alt={relatedProject.id} />
              </Link>
              {relatedProject.title}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default ProjectDetails;
